import React from "react";
import { Play, ArrowDownRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex flex-col justify-end overflow-hidden grain"
    >
      {/* Background image with heavy vintage filter */}
      <div className="absolute inset-0">
        <img
          src="/band-pink.jpg"
          alt="Otto Junior on stage"
          className="w-full h-full object-cover object-[center_30%]"
          style={{ filter: "contrast(1.05) brightness(0.7) saturate(1.05)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-vintage-bg/40 via-vintage-bg/55 to-vintage-bg" />
        <div className="absolute inset-0 bg-gradient-to-r from-vintage-bg/80 via-vintage-bg/20 to-transparent" />
      </div>

      {/* Side label */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left z-10">
        <span className="font-mono text-xs tracking-[0.4em] uppercase text-vintage-gold/70">
          Norway · Touring The World
        </span>
      </div>

      {/* Top-right tagline */}
      <div className="absolute top-32 right-6 md:right-12 z-10 max-w-sm text-right hidden md:block">
        <p className="font-subheading italic text-vintage-cream/85 leading-snug text-lg md:text-xl">
          Playing support for
          <span className="text-vintage-gold not-italic font-medium"> Joe Bonamassa </span>
          and
          <span className="text-vintage-gold not-italic font-medium"> Jimmy Vivino </span>
          — September 2026.
        </p>
      </div>

      {/* Main content */}
      <div className="relative z-10 max-w-7xl w-full mx-auto px-6 md:px-12 pb-16 md:pb-24">
        <div className="fade-up delay-1">
          <p className="font-mono text-xs md:text-sm tracking-[0.4em] uppercase text-vintage-rust mb-6">
            Blues / Rock / Soul / Funk / Psychedelic Blues
          </p>
        </div>

        <h1
          data-testid="hero-title"
          className="font-heading text-[18vw] md:text-[10vw] leading-[0.85] uppercase text-vintage-cream text-shadow-vintage fade-up delay-2"
        >
          Otto Junior
        </h1>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mt-8 fade-up delay-3">
          <p className="font-subheading italic text-xl md:text-2xl text-vintage-cream/85 max-w-2xl leading-snug">
            Otto Junior is a blues artist from Norway, touring the world with
            his original music. He has shared stages with legends like
            Kingfish and Little Steven — and is
            <span className="text-vintage-gold not-italic font-medium"> supporting Joe Bonamassa &amp; Jimmy Vivino in September 2026</span>.
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <a
              href="https://www.youtube.com/watch?v=oRFxNi6hkpw&t=1724s"
              data-testid="hero-listen-btn"
              className="group inline-flex items-center gap-3 bg-vintage-rust text-vintage-cream font-heading text-xl tracking-[0.15em] px-7 py-3 hover:bg-vintage-burgundy transition-all uppercase vintage-shadow-sm"
            >
              <Play size={18} className="fill-current" />
              Listen Now
            </a>
            <a
              href="#tour"
              data-testid="hero-tour-btn"
              className="group inline-flex items-center gap-3 border border-vintage-cream/30 text-vintage-cream font-heading text-xl tracking-[0.15em] px-7 py-3 hover:bg-vintage-cream hover:text-vintage-bg transition-colors uppercase"
            >
              Tour Dates
              <ArrowDownRight size={18} className="group-hover:rotate-45 transition-transform" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom scroll cue */}
      <div className="absolute bottom-6 left-6 md:left-12 z-10 hidden md:flex items-center gap-3">
        <span className="h-px w-12 bg-vintage-gold/60" />
        <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-vintage-gold/60">
          Scroll
        </span>
      </div>
    </section>
  );
}
